export default {
  PROFILE: 'PROFILE',
  PATIENTS: 'PATIENTS',
  ORDERS: 'ORDERS',
  SETTINGS: 'SETTINGS',
} as const
